import { render } from "./GameRecommendationsSelfPage.vue?vue&type=template&id=44f4d90e&scoped=true"
import script from "./GameRecommendationsSelfPage.vue?vue&type=script&lang=js"
export * from "./GameRecommendationsSelfPage.vue?vue&type=script&lang=js"

import "./GameRecommendationsSelfPage.vue?vue&type=style&index=0&id=44f4d90e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f4d90e"]])

export default __exports__